/* eslint-disable max-len */
/* eslint-disable camelcase */
/// ////////////////////////////////////////////////////////////////////////////
// Determine the accessible color of text
/// ////////////////////////////////////////////////////////////////////////////
export const getAccessibleColor = (hex) => {
  let color = hex.replace(/#/g, "");
  // if shorthand notation is passed in
  if (color.length !== 6) {
    color = `${color}${color}`;
  }
  // rgb values
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "#000000" : "#FFFFFF";
};

/// ////////////////////////////////////////////////////////////////////////////
// Change hex color into RGB
/// ////////////////////////////////////////////////////////////////////////////
export const getRGBColor = (hex, type) => {
  let color = hex.replace(/#/g, "");
  // if shorthand notation is passed in
  if (color.length !== 6) {
    color = `${color}${color}`;
  }
  // rgb values
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  return `--color-${type}: ${r}, ${g}, ${b};`;
};

const rgb2hex = (rgb) => {
  // eslint-disable-next-line no-param-reassign
  rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  return rgb && rgb.length === 4
    ? `#${`0${parseInt(rgb[1], 10).toString(16)}`.slice(-2)}${`0${parseInt(rgb[2], 10).toString(16)}`.slice(
        -2
      )}${`0${parseInt(rgb[3], 10).toString(16)}`.slice(-2)}`
    : "";
};

const standardize_color = (str) => {
  const ctx = document.createElement("canvas").getContext("2d");
  ctx.fillStyle = str;
  const style = ctx.fillStyle;
  if (style[0] === "#") {
    return style;
  }
  if (style.substring(0, 3) === "rgb") {
    const [r, g, b] = style.match(/\d+/g).map(Number);
    return `#${r.toString(16)}${g.toString(16)}${b.toString(16)}`;
  }
  return style;
};

const hexToRgb = (hex) =>
  hex
    .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`)
    .substring(1)
    .match(/.{2}/g)
    .map((x) => parseInt(x, 16));
function rgb_is_light(color) {
  const brightness = (color[0] * 299 + color[1] * 587 + color[2] * 114) / 1000;
  return brightness > 155;
}

export const generateDistributorColors = (distributorColor, distributorSecondaryColor) => {
  const colors = {
    primaryColor: distributorColor || "#42B4E6",
    secondaryColor: distributorSecondaryColor || "#43CE5D",
    hoverColor: "#42B4E6",
    textColor: "#FFFFFF",
    hoverTextColor: "#FFFFFF",
    secondaryTextColor: "#FFFFFF",
    secondaryHoverColor: "#0087CD",
    secondaryHoverTextColor: "#FFFFFF"
  };
  try {
    const standardizedColor = standardize_color(distributorColor);
    const standardizedSecondaryColor = standardize_color(distributorSecondaryColor);
    colors.primaryColor = standardizedColor;
    colors.secondaryColor = standardizedSecondaryColor;
    const rgb = hexToRgb(standardizedColor);
    const rgbSecondary = hexToRgb(standardizedSecondaryColor);
    const colorWithFilter = [Math.max(rgb[0] - 30, 0), Math.max(rgb[1] - 30, 0), Math.max(rgb[2] - 30, 0)];
    const secondaryColorWithFilter = [
      Math.max(rgbSecondary[0] - 30, 0),
      Math.max(rgbSecondary[1] - 30, 0),
      Math.max(rgbSecondary[2] - 30, 0)
    ];
    colors.hoverColor = rgb2hex(`rgb(${colorWithFilter[0]},${colorWithFilter[1]},${colorWithFilter[2]})`);
    colors.secondaryHoverColor = rgb2hex(
      `rgb(${secondaryColorWithFilter[0]},${secondaryColorWithFilter[1]},${secondaryColorWithFilter[2]})`
    );
    if (rgb_is_light(rgb)) {
      colors.textColor = "#626469";
    }
    if (rgb_is_light(colorWithFilter)) {
      colors.hoverTextColor = "#626469";
    }
    if (rgb_is_light(rgbSecondary)) {
      colors.secondaryTextColor = "#626469";
    }
    if (rgb_is_light(secondaryColorWithFilter)) {
      colors.secondaryHoverTextColor = "#626469";
    }
  } catch (error) {
    console.log(error);
  }
  return colors;
};
